export default {
  sihuaLu: 'A',
  sihuaQuan: 'B',
  sihuaKe: 'C',
  sihuaJi: 'D',
} as const;
